<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1280px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                    prop="provinceId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.provinceId"
                      filterable
                      clearable
                      placeholder="请选择省区"
                      style="width:100%"
                      @change="changeProvinceFun"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                    prop="cityId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.cityId"
                      filterable
                      clearable
                      placeholder="请选择城市"
                      style="width:100%"
                      @change="changeCityFun"
                    >
                      <el-option
                        v-for="item in cityOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="区县"
                    prop="countyId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.countyId"
                      filterable
                      clearable
                      placeholder="请选择区县"
                      style="width:100%"
                      @change="changeCountyFun"
                    >
                      <el-option
                        v-for="item in countyOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.countyName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="姓名"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.name"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="电话"
                    prop="phone"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.phone"
                      :disabled="eventType!=='add'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="性别">
                    <el-radio-group
                      v-model="dialogAddEditViewForm.sex"
                      :disabled="eventType==='view'"
                    >
                      <el-radio :label="1">
                        男
                      </el-radio>
                      <el-radio :label="2">
                        女
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="地址">
                    <el-input
                      v-model="dialogAddEditViewForm.realAddress"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="标签"
                    prop="tagName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.tagName"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="eventType==='view'"
                  :span="6"
                >
                  <el-form-item label="状态">
                    <el-input
                      v-model="dialogAddEditViewForm.statusStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="eventType==='view'"
                  :span="6"
                >
                  <el-form-item label="成长值">
                    <el-input
                      v-model="dialogAddEditViewForm.integral"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="dialogAddEditViewForm.type === 1 && eventType!=='view'"
            class="modal-box"
          >
            <h3 class="modal-title">
              关联零售户信息
              <el-button
                type="success"
                style="float:right;margin-top:1px;margin-right:10px;"
                @click="handleAddItem"
              >
                添加门店
              </el-button>
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-table
                    :data="relationListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                    />
                    <el-table-column
                      prop="certificateNo"
                      label="专卖证号"
                    >
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.certificateNo" />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="storeName"
                      label="店名"
                    >
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.storeName" />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="benxiangStoreNo"
                      label="本香门店码"
                    >
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.benxiangStoreNo" />
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="eventType === 'edit'"
                      prop="affirmCertificateNo"
                      label="认证专卖证号"
                    />
                    <el-table-column
                      v-if="eventType === 'edit'"
                      prop="affirmStoreName"
                      label="认证店名"
                    />
                    <el-table-column
                      v-if="eventType === 'edit'"
                      prop="affirmBenxiangStoreNo"
                      label="认证门店码"
                    />
                    <el-table-column
                      label="操作"
                      width="90"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="danger"
                          size="mini"
                          @click="handleDeleteItem(scope.$index)"
                        >
                          删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="dialogAddEditViewForm.type === 1 && eventType==='view'"
            class="modal-box"
          >
            <h3 class="modal-title">
              关联零售户信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <view-table
                    :table-columns="relationTableColumns"
                    :table-data="relationListData"
                    table-custom-height="180"
                  />
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="eventType==='view'"
            class="modal-box"
          >
            <h3 class="modal-title">
              成长值信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <view-table
                    :table-columns="integralTableColumns"
                    :table-data="integralListData"
                    table-custom-height="180"
                  />
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import viewTable from '@/components/viewTable'
import { loadAreaDataApi } from '@/api/area'
import { initAppUserApi, saveOrUpdateAppUserApi, listAppUserIntegralListDataApi } from '@/api/appUser'
export default {
  components: { viewTable },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        // return callback(new Error('手机号不能为空'));
        return callback();
      } else {
        const reg = /^1[3|4|5|6|7|8|9]\d{9}$/
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号码'));
        }
      }
    }
    return {
      loading: true,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {
        provinceId: [{ required: true, message: '请选择省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择城市', trigger: 'change' }],
        countyId: [{ required: true, message: '请选择区县', trigger: 'change' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }, { validator: checkPhone, trigger: 'blur' }],
        storeName: [{ required: true, message: '请输入店名', trigger: 'blur' }, { max: 64, message: '最多输入64个字符', trigger: 'blur' }],
        benxiangStoreNo: [{ required: true, message: '请输入本香门店码', trigger: 'blur' }, { max: 32, message: '最多输入32个字符', trigger: 'blur' }],
        certificateNo: [{ max: 32, message: '最多输入32个字符', trigger: 'blur' }],
        tagName: [{ max: 32, message: '最多输入32个字符', trigger: 'blur' }],
        address: [{ max: 512, message: '最多输入512个字符', trigger: 'blur' }],
        realAddress: [{ max: 512, message: '最多输入512个字符', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      cityOptions: [],
      countyOptions: [],
      relationTableColumns: [
        { label: '专卖证号', prop: 'certificateNo', width: 150 },
        { label: '店名', prop: 'storeName', width: 120 },
        { label: '本香门店码', prop: 'benxiangStoreNo', width: 120 },
        { label: '状态', prop: 'statusStr', width: 100 },
        { label: '认证专卖证号', prop: 'affirmCertificateNo', width: 150 },
        { label: '认证店名', prop: 'affirmStoreName', width: 120 },
        { label: '认证本香门店码', prop: 'affirmBenxiangStoreNo', width: 120 },
        { label: '店主姓名', prop: 'ownerName', width: 100 },
        { label: '联系电话', prop: 'affirmPhone', width: 120 },
        { label: '认证地址', prop: 'affirmAddress', width: 280 },
        { label: '认证实际地址', prop: 'affirmRealAddress', width: 280 }
      ],
      relationListData: [],
      integralTableColumns: [
        { label: '来源类型', prop: 'sourceTypeValue', width: 120 },
        { label: '来源名称', prop: 'sourceName', width: 360 },
        { label: '日期', prop: 'integralDateValue', width: 150 },
        { label: '获取成长值', prop: 'integral', width: 120 },
        { label: '备注', prop: 'remark' }
      ],
      integralListData: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          provinceName: '',
          provinceId: '',
          cityName: '',
          cityId: '',
          countyName: '',
          countyId: '',
          name: '',
          phone: '',
          sex: 1,
          tagName: '',
          status: 1,
          statusStr: '',
          integral: 0,
          type: 1,
          storeName: '',
          certificateNo: '',
          benxiangStoreNo: '',
          realAddress: '',
          remark: ''
        }
        this.provinceOptions = []
        this.cityOptions = []
        this.countyOptions = []
        this.relationListData = []
        this.integralListData = []
        if (this.eventType !== 'add') {
          this.initUserData()
        }
        this.initProvinceSelectData()
      }
    }
  },
  methods: {
    // 加载数据
    initUserData () {
      initAppUserApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        this.relationListData = data.relationList
        this.initCitySelectData(data.provinceId)
        this.initCountySelectData(data.cityId)
        if (this.eventType === 'view') {
          this.initIntegralListData()
        }
        this.loading = false
      })
    },
    // 获取用户积分信息
    initIntegralListData () {
      listAppUserIntegralListDataApi({ userId: this.dataId }).then(res => {
        this.integralListData = res.data ? res.data : []
      })
    },
    // 初始省区下拉数据
    initProvinceSelectData () {
      loadAreaDataApi({ parentId: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
        if (this.eventType === 'add') {
          this.loading = false
        }
      })
    },
    // 选择省区回调
    changeProvinceFun (val) {
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
      this.cityOptions = []
      this.dialogAddEditViewForm.cityName = ''
      this.dialogAddEditViewForm.cityId = null
      this.countyOptions = []
      this.dialogAddEditViewForm.countyName = ''
      this.dialogAddEditViewForm.countyId = null
      this.initCitySelectData(val)
    },
    // 初始城市下拉数据
    initCitySelectData (val) {
      loadAreaDataApi({ parentId: val }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    changeCityFun (val) {
      let selectItem = {}
      selectItem = this.cityOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.cityName = selectItem ? selectItem.label : ''
      this.countyOptions = []
      this.dialogAddEditViewForm.countyName = ''
      this.dialogAddEditViewForm.countyId = null
      this.initCountySelectData(val)
    },
    // 初始区县下拉数据
    initCountySelectData (val) {
      loadAreaDataApi({ parentId: val }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.countyOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择区县回调
    changeCountyFun (val) {
      let selectItem = {}
      selectItem = this.countyOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.countyName = selectItem ? selectItem.label : ''
    },
    //添加项目
    handleAddItem () {
      this.relationListData.push({ certificateNo: '', storeName: '', benxiangStoreNo: '' })
    },
    // 删除项目
    handleDeleteItem (index) {
      this.relationListData.splice(index, 1)
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      if (this.dialogAddEditViewForm.type === 1) {
        if (this.relationListData.length === 0) {
          this.$message({
            message: '请添加门店信息',
            type: 'warning'
          })
          return false
        }
        let hasEmpty = false
        this.relationListData.forEach(item => {
          if (item.benxiangStoreNo.trim() === '' || item.storeName.trim() === '') {
            hasEmpty = true
          }
        })
        if (hasEmpty) {
          this.$message({
            message: '店名或者本香门店码不能为空',
            type: 'warning'
          })
          return false
        }
      }
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '用户', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              if (this.dialogAddEditViewForm.type === 1) {
                this.dialogAddEditViewForm.storeName = this.relationListData[0].storeName
                this.dialogAddEditViewForm.certificateNo = this.relationListData[0].certificateNo
                this.dialogAddEditViewForm.benxiangStoreNo = this.relationListData[0].benxiangStoreNo
                this.dialogAddEditViewForm.storeData = JSON.stringify(this.relationListData)
              }
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave () {
      saveOrUpdateAppUserApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
</style>
